import * as z from "zod/v4";

export const getAeoPromptDetails = {
  name: "getAeoPromptDetails" as const,
  input: z.object({ promptId: z.string() }),
  output: z
    .object({
      id: z.string(),
      prompt: z.string(),
      category: z.string(),
      createdAt: z.string(),
      deletedAt: z.string().nullable(),
    })
    .nullable(),
};
